import { Fragment } from "react";

function inline(text) {
  const parts = String(text).split(/(\*\*[^*]+\*\*|\[[^\]]+\]\(https?:\/\/[^)]+\))/g);
  return parts.map((part, index) => {
    const bold = part.match(/^\*\*(.+)\*\*$/);
    if (bold) return <strong key={index}>{bold[1]}</strong>;
    const link = part.match(/^\[([^\]]+)\]\((https?:\/\/[^)]+)\)$/);
    if (link) return <a key={index} href={link[2]} target="_blank" rel="noreferrer noopener">{link[1]}</a>;
    return <Fragment key={index}>{part}</Fragment>;
  });
}

export default function MarkdownText({ children, className = "" }) {
  const lines = String(children || "").replace(/\r/g, "").split("\n");
  const blocks = [];
  let list = [];
  const flush = () => {
    if (!list.length) return;
    blocks.push(<ul key={`list-${blocks.length}`}>{list.map((item, index) => <li key={index}>{inline(item)}</li>)}</ul>);
    list = [];
  };
  lines.forEach((line, index) => {
    const listItem = line.match(/^\s*(?:[-*]|\d+[.)])\s+(.+)/);
    if (listItem) {
      list.push(listItem[1]);
      return;
    }
    flush();
    const heading = line.match(/^\s*#{1,4}\s+(.+)/);
    if (heading) blocks.push(<h3 key={index}>{inline(heading[1])}</h3>);
    else if (line.trim()) blocks.push(<p key={index}>{inline(line.trim())}</p>);
  });
  flush();
  return <div className={`markdown-text ${className}`}>{blocks}</div>;
}
